
import { useState } from "react";
import XButton from "../common/XButton";

const PartnerSearchBar = ({
    partnerName,
    setSearchTerm,
    // optional: a caller whose setSearchTerm already rewinds the pagination has nothing to do here
    resetCursorAndcurrentPage = () => {}
}) => {
    const [showSearchInput, setShowSearchInput] = useState(true);
    const [inputText, setInputText] = useState("");

    const doSearch = () => {
        resetCursorAndcurrentPage();
        setSearchTerm(inputText.trim());
    };

    return (
        <div className="block bg-surface text-content border-b p-1.5">
            <div className="flex justify-between mb-2">
                <strong>{partnerName} Cases</strong>
                {!showSearchInput && <XButton
                    variant="close"
                    onClick={() => setShowSearchInput(true)}
                    className="text-primary flex items-center gap-2"
                    aria-label="Search cases"
                >
                    <i className="fa fa-search" />
                    <span>Search Cases</span>
                </XButton>}
                {showSearchInput && <XButton
                    variant="close"
                    onClick={() => { setShowSearchInput(false); setInputText(""); setSearchTerm("");  resetCursorAndcurrentPage()}}
                    id="closeSearch"
                    aria-label="Close search"
                >
                    <i className="fa fa-times text-xl"></i>
                </XButton>}
            </div>
            {showSearchInput && <div id="searchBox" className="mt-2 mb-2">
                <div className="input-group">
                    <input
                        type='text'
                        className="form-control search-input border-r-0! rounded-tr-none! rounded-br-none! rounded-l-md! shadow-none focus:shadow-none focus:border-border focus:z-[1]"
                        placeholder="Search Cases"
                        value={inputText}
                        onChange={e => setInputText(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                e.stopPropagation();
                                doSearch();
                            }
                        }}
                    />
                    <span className="input-group-text border-l-0 rounded-tl-none rounded-bl-none rounded-r-md bg-white px-3 flex items-center" onClick={doSearch} role="button" tabIndex={0}>
                        <i className="fa fa-search text-primary!"></i>
                    </span> 
                </div>
            </div>}
        </div>
    )

}

export default PartnerSearchBar;